// extracted by mini-css-extract-plugin
module.exports = {"container":"NavItem_container__2WYhw","active":"NavItem_active__1GyWo"};